import { CommonModule } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatDialogClose } from '@angular/material/dialog';

@Component({
    selector: 'app-confirmation-modal',
    standalone: true,
    imports: [CommonModule, MatButtonModule, MatDialogClose],
    templateUrl: './confirmation-modal.component.html',
    styleUrls: ['./confirmation-modal.component.scss'],
    // changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ConfirmationModalComponent implements OnInit {

    constructor(
    ) { }

    ngOnInit(): void {

    }
}
